import React, { Fragment, useState } from 'react';
import { Button, TextArea } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import { resolvePlaceholders } from 'routes/screens/response/utils';
import Spacer from 'shared/components/Spacer';
import { SurveyResponseType } from 'shared/types';
import { convertQuillHTMLToText } from 'shared/utils';
import { DrawerBody, DrawerFooter } from '../../list/style';

type EditResponseDrawerType = {
  editableResponseQuestions: Record<string, EditableResponsesType>;
  surveyQuestions: any;
  setEditOpen: (editOpen: boolean) => void;
  handleUpdate: (values: any) => void;
  responseData?: SurveyResponseType;
  placeholders: Record<string, string>;
};

enum EditableResponseQuestionsType {
  PARAGRAPH = 'PARAGRAPH',
  TEXT = 'TEXT',
}

type EditableResponsesType = {
  comment?: string | null;
  is_deleted?: boolean | null;
  question_type?: EditableResponseQuestionsType | null;
  required?: boolean | null;
  value?: string | null;
};

const EditResponseDrawer = (props: EditResponseDrawerType) => {
  const { t } = useTranslation();
  const {
    editableResponseQuestions,
    surveyQuestions,
    setEditOpen,
    placeholders,
    handleUpdate,
    responseData,
  } = props;
  const [updatedValues, setUpdatedValues] = useState<
    Record<string, EditableResponsesType>
  >(editableResponseQuestions);

  return (
    <>
      <DrawerBody className="edit-response">
        <h4> {t('responses.edit.edit_response')} </h4>
        <h6>{t('responses.edit.edit_ques_type')}</h6>
        <div style={{ paddingTop: '6px' }}>
          {updatedValues &&
            Object.keys(updatedValues).map((question) => (
              <>
                {updatedValues[question].is_deleted &&
                responseData?.question_answers[question] ? (
                  <div className="edit-deleted">
                    <div className="deleted-text">{t('deleted_question')}</div>
                    <div className="deleted-question">
                      {resolvePlaceholders({
                        text: convertQuillHTMLToText(
                          surveyQuestions.find((q: any) => q.name === question)
                            ?.text || '',
                        ),
                        placeholders,
                      })}
                    </div>
                    <div className="deleted-answer">
                      {updatedValues[question].value}
                    </div>
                  </div>
                ) : (
                  !updatedValues[question]?.is_deleted && (
                    <Fragment key={question}>
                      <TextArea
                        label={resolvePlaceholders({
                          text: convertQuillHTMLToText(
                            surveyQuestions.find(
                              (q: any) => q.name === question,
                            )?.text || '',
                          ),
                          placeholders,
                        })}
                        isErrored={
                          !updatedValues[question] &&
                          updatedValues[question].required &&
                          !Object.keys(updatedValues[question])?.length
                        }
                        defaultValue={updatedValues?.[question]?.value || ''}
                        disabled={
                          !updatedValues?.[question] &&
                          updatedValues[question].is_deleted
                        }
                        onChange={(e: any) =>
                          setUpdatedValues({
                            ...updatedValues,
                            [question]: {
                              ...updatedValues[question],
                              value: e.target.value,
                            },
                          })
                        }
                        maxLength={
                          updatedValues?.[question]?.question_type ===
                          EditableResponseQuestionsType.TEXT
                            ? 256
                            : 1500
                        }
                        value={updatedValues?.[question]?.value || ''}
                        showCount={true}
                      />
                      <Spacer y={1} />
                    </Fragment>
                  )
                )}
              </>
            ))}
        </div>
      </DrawerBody>
      <DrawerFooter>
        <Button inline type="secondary" onClick={() => setEditOpen(false)}>
          {t('cancel')}
        </Button>
        <Button
          inline
          htmlType="submit"
          onClick={() => handleUpdate(updatedValues)}
        >
          {t('save')}
        </Button>
      </DrawerFooter>
    </>
  );
};

export default EditResponseDrawer;
